<template>
    <div class="login">
        <fake-home></fake-home>
    </div>
</template>

<script>
    import ForgotPassword from '@theme-views/public/pages/Login/ForgotPassword'
    import Login from '@views/public/pages/Login/login'
    import FakeHome from '@theme-views/user/pages/Home/FakeHome'
    import SvgUser from '@theme-views/common/SvgIcon/Icons/User'
    import SvgLock from '@theme-views/common/SvgIcon/Icons/Lock'
    import {checkNull} from '@/helpers'

    export default {
        mixins: [Login],
        data() {
            return {
                open_forgot_pass: false
            }
        },
        methods: {
            openForgotPass() {
                this.$router.push({name: 'login', query: { openForgotPass: true } })
            },
            routeCheck(route) {
              this.open_forgot_pass = checkNull(route.query.openForgotPass) ? true : false
            },
            changeModalToForgotPass() {
                this.$root.$children[0].changeModalContent({
                    name: 'forgot-pass-pop-up',
                    hasCloseButton: true,
                    alignCenter: true,
                    canCloseBackDrop: false,
                    layoutType: 'm-dark'
                })
            },
            capitalize(s) {
                if (typeof s !== 'string') return ''
                return s.charAt(0).toUpperCase() + s.slice(1)
            }
        },
        computed: {
            login_title() {
                return this.$root.$children[0].width > 1199 ? '' : 'Login'
            }
        },
        watch: {
            '$route' (to, from) {
                this.routeCheck(to)
            }
        },
        created() {
            this.routeCheck(this.$route)
        },
        mounted() {
            this.$root.$children[0].changeModalContent({
                name: 'login-pop-up',
                hasCloseButton: true,
                alignCenter: true,
                canCloseBackDrop: true,
                extraClasses: "mobile-dark centered login-content",
                mobileBreakpoint: 1199,
                onClose: () => {
                    this.$router.push({ name: 'home' })
                }
            })
            this.$root.$children[0].openModal()
        },
        components: {
            ForgotPassword,
            FakeHome,
            SvgUser,
            SvgLock,
        }
    }
</script>

<style lang="scss" src="./login.scss"></style>
